import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { toast } from 'sonner';
import { queryClient } from '~app/query-client';
import { QUERY_KEYS } from '~shared/api/query-keys';
import Axios from 'axios';
import type { ErrorWithMessage } from '~shared/api/types/error-with-message';
import { useLogout } from '../hooks/use-logout';

export const updateCurrentUserPasswordAPI = async (newPassword: string, currentPassword: string) => {
  const response = await baseAPI.patch<unknown>(`/users/change-password`, {
    password: currentPassword,
    newPassword,
  });
  return response.data;
};

export const useUpdateCurrentUserPassword = () => {
  const logout = useLogout();
  return useMutation({
    mutationFn: ({ newPassword, currentPassword }: { newPassword: string, currentPassword: string }) => updateCurrentUserPasswordAPI(newPassword, currentPassword),
    onSuccess: () => {
      toast.success('Password updated successfully');
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.CURRENT_USER() });
    },
    onError: (error) => {
      if (Axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          logout();
          return toast.error('This account does not exist');
        }
        const errorMessage = (error.response?.data as ErrorWithMessage).error?.message ?? 'Failed to update password';
        return toast.error(errorMessage);
      } else {
        return toast.error('Failed to update password');
      }
    },
  });
};

